import { render } from "./RightSidenav.vue?vue&type=template&id=409472ad&scoped=true"
import script from "./RightSidenav.vue?vue&type=script&lang=js"
export * from "./RightSidenav.vue?vue&type=script&lang=js"

import "./RightSidenav.vue?vue&type=style&index=0&id=409472ad&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409472ad"]])

export default __exports__